import Vue from 'vue';
import Vuex from 'vuex';
import account from './modules/account';
import common from './modules/common';
import dataExport from './modules/data-export';
Vue.use(Vuex);

// 数据持久插件
const saveStoragePlugin = (store) => {
  const storageState = window.localStorage.getItem('store');
  store.replaceState(Object.assign({}, store.state, JSON.parse(storageState)));

  store.subscribe((mutation, state) => {
    const JsonState = JSON.stringify(state);
    window.localStorage.setItem('store', JsonState);
  });
};

export default new Vuex.Store({
  modules: {
    account,
    common,
    dataExport
  },
  plugins: [saveStoragePlugin]
});
